import { render, staticRenderFns } from "./TraceabilityCard.vue?vue&type=template&id=fcedb36e&scoped=true"
import script from "./TraceabilityCard.vue?vue&type=script&lang=js"
export * from "./TraceabilityCard.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityCard.vue?vue&type=style&index=0&id=fcedb36e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcedb36e",
  null
  
)

export default component.exports